<a
  href="javascript:void(0)"
  class="list-group-item gast-list-group-item collapsed"
  data-bs-toggle="collapse"
  attr.data-bs-target="#{{ id() }}">
  {{ useTranslation() ? (label() | translate) : label() }}<span class="mr-3"> <i class="fas fa-arrow-right"></i></span
></a>
@if (useTranslation()) {
  <div [attr.id]="id()" class="sublinks collapse" [innerHtml]="content() | translate"></div>
} @else {
  <div [attr.id]="id()" class="sublinks collapse" [innerHtml]="content()"></div>
}
